// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"2fae6b7405fa884b72c4","678":"cf821bfbf9906ff04bac"}[chunkId] + ".js";
};